<template>
  <div class="fb-wrapper">
    <div class="fb-container">
      <!-- Search row -->
      <div class="fb-search-row">
        <div class="fb-search-input-wrap">
          <i class="material-icons fb-search-icon">search</i>
          <input
            :placeholder="filters.elements.search.options.hint"
            v-model="searchText"
            type="search"
            @change="searchChild"
            class="fb-search-input"
          />
        </div>
        <button @click="showMore = !showMore" class="fb-toggle-btn" :class="{ 'fb-toggle-active': showMore }">
          <i class="material-icons">{{ showMore ? 'keyboard_arrow_up' : 'tune' }}</i>
        </button>
      </div>

      <!-- Expandable filters -->
      <div v-if="showMore" class="fb-filters-panel">
        <div class="fb-filters-grid">
          <div v-for="(item, index) in filters.elements.champs" :key="index" class="fb-filter-item" v-show="isShown(item)">
            <label class="fb-filter-label">{{ item.label }}</label>
            <!-- Select -->
            <select
              v-if="item.type == 'select'"
              :name="item.key"
              :id="item.key"
              v-model="filter[item.key]"
              class="fb-filter-select"
            >
              <option selected disabled :value="null">{{ item.key }}</option>
              <option v-for="o in item.values" :key="o.key || o._id || o" :value="o._id || o">{{ o.name || o.username || o.fullName || o }}</option>
            </select>
            <!-- Number -->
            <input
              v-if="item.type == 'number'"
              :max="item.max"
              :min="item.min"
              :placeholder="item.name"
              :step="item.step"
              v-model="filter[item.key]"
              type="number"
              :name="item.key"
              :id="item.key"
              class="fb-filter-number"
            />
          </div>
        </div>

        <!-- Action buttons -->
        <div class="fb-actions">
          <button @click="ClearFilters" class="fb-btn-reset">
            <i class="material-icons" style="font-size:16px;margin-right:4px">refresh</i> Reset
          </button>
          <button @click="filtrer" class="fb-btn-filter">
            <i class="material-icons" style="font-size:16px;margin-right:4px">filter_list</i> Filter
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    filters: { required: true, type: Object},
    name: { type: String, default: "" },
    pFiltrer: { type: Function },
    pSearch: { type: Function },
    reset: { type: Function },
  },
  data() {
    return {
      showMore: false,
      searchText: "",
      filter: {},
    };
  },
  mounted() {

  },
  methods: {
    isShown(item) {
      let shown =
        !item.show ||
        (item.show && this.filter[item.show.key] == item.show.equal);
      if (!shown) this.$set(this.filter, item.key, null);
      return shown;
    },
    searc() {
    },
    async searchChild() {
        this.$emit('search',this.searchText);
    },
    async filtrer() {
        this.$emit('filtrer',this.filter);
    },
    async ClearFilters(val) {
      this.$emit('reset',val);
    },
  },
};
</script>

<style>
/* Filter Bar Styles */
.fb-wrapper {
  padding: 12px 12px 0;
}
.fb-container {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  padding: 14px 16px;
  transition: box-shadow 0.2s;
}
.fb-container:focus-within {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
}

/* Search row */
.fb-search-row {
  display: flex;
  align-items: center;
  gap: 10px;
}
.fb-search-input-wrap {
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
}
.fb-search-icon {
  position: absolute;
  left: 12px;
  font-size: 20px;
  color: #94a3b8;
  pointer-events: none;
}
.fb-search-input {
  width: 100%;
  padding: 10px 14px 10px 40px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 13px;
  color: #1e293b;
  background: #f8fafc;
  outline: none;
  transition: all 0.2s;
}
.fb-search-input:focus {
  border-color: #4285f4;
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(66, 133, 244, 0.1);
}
.fb-search-input::placeholder {
  color: #94a3b8;
}

/* Toggle button */
.fb-toggle-btn {
  width: 40px;
  height: 40px;
  min-width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s;
  outline: none;
}
.fb-toggle-btn:hover {
  background: #e2e8f0;
  color: #1e293b;
}
.fb-toggle-btn.fb-toggle-active {
  background: #4285f4;
  border-color: #4285f4;
  color: #ffffff;
}

/* Filters panel */
.fb-filters-panel {
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px dashed #e2e8f0;
}

/* Filters grid */
.fb-filters-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 12px;
  margin-bottom: 14px;
}
.fb-filter-item {
  display: flex;
  flex-direction: column;
}
.fb-filter-label {
  font-size: 11px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}
.fb-filter-select,
.fb-filter-number {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 13px;
  color: #1e293b;
  background: #f8fafc;
  outline: none;
  transition: all 0.2s;
  appearance: auto;
}
.fb-filter-select:focus,
.fb-filter-number:focus {
  border-color: #4285f4;
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(66, 133, 244, 0.1);
}

/* Action buttons */
.fb-actions {
  display: flex;
  justify-content: center;
  gap: 10px;
  padding-top: 4px;
}
.fb-btn-reset {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 24px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #64748b;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  outline: none;
}
.fb-btn-reset:hover {
  background: #f1f5f9;
  color: #1e293b;
}
.fb-btn-filter {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 24px;
  border-radius: 8px;
  border: none;
  background: #4285f4;
  color: #ffffff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  outline: none;
}
.fb-btn-filter:hover {
  background: #3367d6;
}

@media (max-width: 640px) {
  .fb-filters-grid {
    grid-template-columns: 1fr;
  }
  .fb-actions {
    flex-direction: column;
  }
  .fb-btn-reset,
  .fb-btn-filter {
    width: 100%;
  }
}
</style>
